<template>
  <div class="homeGoods">
    <div class="showCase">
      <span class="showCase-title">
        <span class="left">{{ $t("business.choiceness") }}</span>
        <span class="right" @click="setShowcase">{{ $t("business.viewAll") }}</span>
      </span>
      <div
        class="showCase-list"
        v-if="productShowcaseList && productShowcaseList.length > 0"
      >
        <div
          class="product"
          v-for="(product, idx) in productShowcaseList"
          :key="idx"
        >
          <div class="image" @click="toDetail(product.PId)">
            <el-image
              :src="imgUrlFilter(product.ProductCover)"
              fit="contain"
            ></el-image>
            <div class="showcase" v-if="product.IsSetProductShowcase">
              {{ $t("business.showcase") }}
            </div>
          </div>
          <div class="title">{{ product.ProductName }}</div>
          <div class="buttons" v-if="isAdmin">
            <el-button-group>
              <el-button
                type="primary"
                size="small"
                @click="toEdit(product.PId)"
                >{{ $t("business.edit") }}</el-button
              >
              <el-button
                type="warning"
                size="small"
                @click="setState(product.PId, 0)"
                v-if="product.ProductState"
                >{{ $t("business.state2") }}</el-button
              >
              <el-button
                type="warning"
                size="small"
                @click="setState(product.PId, 1)"
                v-else
                >{{ $t("business.state1") }}</el-button
              >
              <el-button
                type="danger"
                size="small"
                @click="toDelete(product.PId)"
                >{{ $t("business.delete") }}</el-button
              >
            </el-button-group>
          </div>
          <div class="buttons" v-else>
            <el-button-group>
              <el-button
                type="warning"
                size="small"
                class="basket-button"
                @click="toBasket(product)"
                >{{ $t("B2B.toBasket") }}</el-button
              >
              <el-button
                type="primary"
                size="small"
                @click="toEnquiry(product.PId)"
                >{{ $t("B2B.inquiry") }}</el-button
              >
            </el-button-group>
          </div>
        </div>
      </div>
      <div class="empty" v-else>{{ $t("business.noProduct") }}</div>
    </div>

    <div class="list" v-if="businessClassList && businessClassList.length > 0">
      <div
        class="business"
        v-for="(item, index) in businessClassList"
        :key="index"
      >
        <div class="business-name">
          <span class="left">{{ item.ClassName }}</span>
          <span class="right" @click="setCategory(item.ClassName, item.BPCId)"
            >{{ $t("business.viewAll") }}</span
          >
        </div>
        <div
          class="business-product"
          v-if="item.ProductList && item.ProductList.length > 0"
        >
          <div
            class="product"
            v-for="(product, idx) in item.ProductList"
            :key="idx"
          >
            <div class="image" @click="toDetail(product.PId)">
              <el-image
                :src="imgUrlFilter(product.ProductCover)"
                fit="contain"
              ></el-image>
              <div class="showcase" v-if="product.IsSetProductShowcase">
                {{ $t("business.showcase") }}
              </div>
            </div>
            <div class="title">{{ product.ProductName }}</div>
            <div class="buttons" v-if="isAdmin">
              <el-button-group>
                <el-button
                  type="primary"
                  size="small"
                  @click="toEdit(product.PId)"
                  >{{ $t("business.edit") }}</el-button
                >
                <el-button
                  type="warning"
                  size="small"
                  @click="setState(product.PId, 0)"
                  v-if="product.ProductState"
                  >{{ $t("business.state2") }}</el-button
                >
                <el-button
                  type="warning"
                  size="small"
                  @click="setState(product.PId, 1)"
                  v-else
                  >{{ $t("business.state1") }}</el-button
                >
                <el-button
                  type="danger"
                  size="small"
                  @click="toDelete(product.PId)"
                  >{{ $t("business.delete") }}</el-button
                >
              </el-button-group>
            </div>
            <div class="buttons" v-else>
              <el-button-group>
                <el-button
                  type="warning"
                  size="small"
                  class="basket-button"
                  @click="toBasket(product)"
                  >{{ $t("B2B.toBasket") }}</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  @click="toEnquiry(product.PId)"
                  >{{ $t("B2B.inquiry") }}</el-button
                >
              </el-button-group>
            </div>
          </div>
        </div>
        <div class="empty" v-else>{{ $t("business.noProduct") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapActions } from "vuex";
import { SET_BASKET } from "../../../store/mutation-types";

export default {
  name: "HomeGoods",
  props: ["businessClassList", "productShowcaseList", "isAdmin"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    ...mapMutations([SET_BASKET]),
    ...mapActions({ getBasketProducts: "getBasket" }),
    toBasket(val) {
      var product = {
        PId: val.PId,
        ProductName: val.ProductName,
        ProductImage: val.ProductCover,
        ShopId: val.ShopId,
        CompanyName: val.CompanyName
      };
      this.getBasketProducts().then(res => {
        var prduct = res.products.find(p => p.PId == val.PId);
        if (prduct) {
          this.$message.error(this.$t("B2B.repeat"));
        } else {
          this.$message.success(this.$t("B2B.addSuccess"));
          this.$bus.$emit("showBasket", { show: true, activeTab: "first" });
        }
        this.SET_BASKET({ product: product, type: 1 });
      });
    },
    toDetail(productNumber) {
      this.$router.push({
        path: "/commodity",
        query: { ProductNumber: productNumber, IsAdmin: this.isAdmin }
      });
    },
    toEnquiry(productNumber) {
      this.$router.push({
        path: "/enquiry",
        query: { PIdList: [productNumber] }
      });
    },
    toEdit(productNumber) {
      this.$router.push({
        path: "/commodityEdit",
        query: { ProductNumber: productNumber }
      });
    },
    toDelete(productNumber) {
      this.$emit("toDelete", productNumber);
    },
    setState(productNumber, state) {
      this.$emit("setState", productNumber, state);
    },
    setCategory(name, id) {
      this.$emit("setCategory", name, id);
    },
    setShowcase() {
      this.$emit("setShowcase");
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value.split("|")[0]);
    }
  }
};
</script>
<style lang="scss">
.homeGoods {
  .empty {
    display: block;
    text-align: center;
    width: 100%;
    line-height: 200px;
    color: #999;
  }
  .list {
    display: inline-block;
    overflow: hidden;
    width: 100%;
    .business {
      margin-top: 2%;
      .business-name {
        .left {
          font-weight: bold;
          font-size: 20px;
          display: inline-block;
          width: 50%;
          vertical-align: middle;
        }
        .right {
          color: #fc5e08;
          display: inline-block;
          width: 50%;
          vertical-align: middle;
          text-align: right;
          cursor: pointer;
          text-decoration: underline;
        }
      }
      .business-product {
        .product {
          display: inline-block;
          margin-top: 2%;
          margin-right: 5%;
          width: 20%;
          overflow: hidden;
          text-align: center;
          .image {
            background: rgb(244, 245, 246);
            vertical-align: middle;
            position: relative;
            cursor: pointer;
            .el-image {
              width: auto;
              height: 200px;
            }
            .showcase {
              position: absolute;
              right: 0;
              bottom: 0;
              background: #fc5e08;
              color: #fff;
              padding: 3px 5px;
              font-size: 13px;
            }
          }
          .title {
            font-weight: bold;
            margin: 10px auto;
            padding: 0;
            width: 90%;
            font-size: 14px;
            height: 20px;
            line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .buttons {
            .basket-button {
              background: linear-gradient(
                270.13deg,
                #f58603 0.13%,
                #fb3f04 99.91%
              );
            }
          }
        }
      }
    }
  }
  .showCase {
    display: inline-block;
    overflow: hidden;
    width: 100%;
    margin-top: 2%;
    .showCase-title {
      .left {
        font-weight: bold;
        font-size: 20px;
        display: inline-block;
        width: 50%;
        vertical-align: middle;
      }
      .right {
        color: #fc5e08;
        display: inline-block;
        width: 50%;
        vertical-align: middle;
        text-align: right;
        cursor: pointer;
        text-decoration: underline;
      }
    }
    .showCase-list {
      .product {
        display: inline-block;
        margin-top: 2%;
        margin-right: 5%;
        width: 20%;
        overflow: hidden;
        text-align: center;
        .image {
          background: rgb(244, 245, 246);
          vertical-align: middle;
          position: relative;
          cursor: pointer;
          .el-image {
            width: auto;
            height: 200px;
          }
          .showcase {
            position: absolute;
            right: 0;
            bottom: 0;
            background: #fc5e08;
            color: #fff;
            padding: 3px 5px;
            font-size: 13px;
          }
        }
        .title {
          font-weight: bold;
          margin: 10px auto;
          padding: 0;
          width: 90%;
          font-size: 14px;
          height: 20px;
          line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .buttons {
          .basket-button {
            background: linear-gradient(
              270.13deg,
              #f58603 0.13%,
              #fb3f04 99.91%
            );
          }
        }
      }
    }
  }
}
</style>
